// extracted by mini-css-extract-plugin
export var notificationHost = "_cb-0";